var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulbSmall = function SvgBulbSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bulb-small_svg__a",
    width: "105.8%",
    height: "107.6%",
    x: "-2.9%",
    y: "-3.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.304622592 0 0 0 0 0.578497024 0 0 0 0.129971591 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "bulb-small_svg__b",
    d: "M0 0h800v608H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M-624-524H816V500H-624z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -284)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bulb-small_svg__b",
    fill: "#000",
    filter: "url(#bulb-small_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bulb-small_svg__b",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    d: "M14.167.833c.46 0 .833.373.833.834V2.5c0 .46-.373.833-.833.833h-.834v3.97l6.543 10.592a.833.833 0 0 1-.71 1.272h-17.5a.833.833 0 0 1-.708-1.272L7.5 7.303v-3.97h-.833a.833.833 0 0 1-.834-.833v-.833c0-.46.373-.834.834-.834zM15.563 12.5h-1.345l1.97 3.205a.42.42 0 0 1-.07.522l-.066.051a.417.417 0 0 1-.574-.136l-2.238-3.642H5.269l-3.602 5.834h17.5zM12.5 3.333H8.333V7.54l-2.549 4.126h6.944L11.317 9.37a.42.42 0 0 1 .07-.522l.067-.051a.417.417 0 0 1 .573.136l1.679 2.733h1.342L12.5 7.54zm1.667-1.666h-7.5V2.5h7.5z"
  }))));
};
export default SvgBulbSmall;